var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"dark":"","color":"navy"}},[_c('v-row',{attrs:{"justify":"end"}},[_c('a',{attrs:{"href":"https://selflane.com"}},[_vm._v("© "+_vm._s(new Date().getFullYear())+" Selflane.com")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }